











import Vue from 'vue'
import Container from '@/components/Container.vue'
import GridLines from '@/components/GridLines.vue'
import Navbar from '@/components/Navbar.vue'

export default Vue.extend({
  name: 'app',
  components: {
    Container,
    GridLines,
    Navbar
  },
  data() {
    return {
      transitionName: 'fade',
      transitionMode: 'out-in'
    }
  },
  watch: {
    $route(to, from) {
      if (to.path.includes('/project') && from.path.includes('/project')) {
        this.transitionName = 'slideup'
      } else {
        this.transitionName = 'fade'
      }
    }
  }
})
